import { type SortDirection, Table } from '@factorialco/deprecated-design-system'

import type { ColumnNames } from 'modules/app_store/pages/SettingsPage/Apps/common/types'

interface Props {
  columnNames: ColumnNames
  onSort: (attribute: string, direction: SortDirection) => void
  attribute: string
  direction: SortDirection
}

const Header = ({ columnNames, onSort, attribute, direction }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        {columnNames.map((title) => (
          <Table.SortableHeadCell
            colSpan={title.colSpan}
            key={title.name}
            attribute={title.attribute}
            onSort={onSort}
            sortAttribute={attribute}
            sortDirection={direction}
          >
            {title.name}
          </Table.SortableHeadCell>
        ))}
        <Table.HeadCell colSpan={4}>Code</Table.HeadCell>
      </Table.Row>
    </Table.Head>
  )
}

export default Header
